__turbopack_context__.v({
  "container": "ModelList-module__tYTy-G__container",
  "fadeInItems": "ModelList-module__tYTy-G__fadeInItems",
  "noItems": "ModelList-module__tYTy-G__noItems",
  "spacing--lg": "ModelList-module__tYTy-G__spacing--lg",
  "spacing--md": "ModelList-module__tYTy-G__spacing--md",
  "spacing--sm": "ModelList-module__tYTy-G__spacing--sm",
  "spacing--xl": "ModelList-module__tYTy-G__spacing--xl",
  "spacing--xs": "ModelList-module__tYTy-G__spacing--xs",
  "spacing--xxl": "ModelList-module__tYTy-G__spacing--xxl",
  "spacing--xxs": "ModelList-module__tYTy-G__spacing--xxs",
  "spacing--xxxl": "ModelList-module__tYTy-G__spacing--xxxl",
  "spacing--xxxs": "ModelList-module__tYTy-G__spacing--xxxs",
});
